import React from 'react';
import { Interpolation, Theme } from '@emotion/react';
import { cx } from '@linaria/atomic';
import { theme } from '@frontend/theme';
import { AnimatedBadgeStyles } from './animated-badge.styles';

export type BadgeProps = {
  label: string;
  animated?: boolean;
  /** @deprecated use className instead */
  styles?: Interpolation<Theme>;
  className?: string;
} & ExtendedCssProps;

type ExtendedCssProps = {
  animationSpeed?: number;
  bgColor?: string;
  blurIntensity?: string;
  highlightColor?: string;
  primaryColor?: string;
  textColor?: string;
};

export const AnimatedBadge: React.FC<BadgeProps> = ({
  animated = true,
  animationSpeed = 1.8,
  bgColor = theme.colors.secondary.seaweed50,
  blurIntensity = theme.spacing(2),
  className,
  highlightColor = theme.colors.secondary.seaweed20,
  label,
  primaryColor = theme.colors.secondary.seaweed70,
  styles,
  textColor = theme.colors.white,
}) => {
  const cssVars = {
    '--animated-badge-speed': `${animationSpeed}s`,
    '--animated-badge-bg': bgColor,
    '--animated-badge-blur': blurIntensity,
    '--animated-badge-highlight': highlightColor,
    '--animated-badge-primary': primaryColor,
    '--animated-badge-text': textColor,
  } as React.CSSProperties;

  return animated ? (
    <div css={styles} className={cx(AnimatedBadgeStyles.animatedBadge, className)} style={cssVars}>
      <span css={styles} className={cx(AnimatedBadgeStyles.animatedBadgeContent, className)}>
        {label}
      </span>
    </div>
  ) : (
    <span css={styles} className={cx(AnimatedBadgeStyles.badgeContent, className)} style={cssVars}>
      {label}
    </span>
  );
};
